import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useCategory } from '~/composables/_next/useCategory';
import { useFacet } from '~/composables/_next/useFacet';
import { getFacetGrouped } from '~/composables/_next/facetGetters';
import { useSearchFacets } from '@/composables/_next/useSearchFacets';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useUser } from '~/composables/_next/useUser';
import useMobileObserver from '~/composables/useMobileObserver';
import { ProductAttributes, ProductKeys } from '@/types/ProductEnums';
import { PROBLEM_LABELS, PRODUCT_ATTRIBUTES_FILTERS } from '~/types/FiltersConst';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useProductListingStore() {
  var route = useRoute();
  var slug = route.params.slug;
  var _useGetTranslations = useGetTranslations(),
    translate = _useGetTranslations.translate;
  var _useMobileObserver = useMobileObserver(),
    isMobile = _useMobileObserver.isMobile;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    country = _useLocalization.country;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useSearchFacets = useSearchFacets(),
    facets = _useSearchFacets.facets;

  /**
   * Extracts the key of the product listing category from `productListingContent`
   */
  var productListingContentKey = computed(function () {
    var _productListingConten;
    return (_productListingConten = productListingContent.value) === null || _productListingConten === void 0 ? void 0 : _productListingConten.commercetoolsExternalId;
  });
  var productListingRelatedCategories = computed(function () {
    var _productListingConten2, _productListingConten3, _productListingConten4;
    var sisterCategories = (_productListingConten2 = (_productListingConten3 = productListingContent.value) === null || _productListingConten3 === void 0 ? void 0 : (_productListingConten4 = _productListingConten3.sisterCategoriesCollection) === null || _productListingConten4 === void 0 ? void 0 : _productListingConten4.items) !== null && _productListingConten2 !== void 0 ? _productListingConten2 : [];
    // keep only sister categories with an existing slug in current locale
    return sisterCategories.filter(function (category) {
      return category.slug != null;
    });
  });
  function getPriceRange() {
    var _ref, _ref2;
    var query = route.query;
    var minPrice = query['min-price'];
    var maxPrice = query['max-price'];
    if (!minPrice && !maxPrice) return;
    return "range (".concat((_ref = minPrice * 100) !== null && _ref !== void 0 ? _ref : '*', " to ").concat((_ref2 = maxPrice * 100) !== null && _ref2 !== void 0 ? _ref2 : '*', ")");
  }

  /**
   * Stores the search results for the current listing and facets.
   */
  var productListing = useState("product-listing-".concat(slug), function () {
    return [];
  });
  var productListingCategories = useState("product-listing-categories-".concat(slug), function () {
    return [];
  });
  var productListingFacets = useState("product-listing-facets-".concat(slug), function () {
    return [];
  });
  var _useFacet = useFacet('categories'),
    result = _useFacet.result,
    search = _useFacet.search;
  var _useCategory = useCategory('getCurrentCategories'),
    categoryResult = _useCategory.categories,
    categorySearch = _useCategory.search;
  var _useUser = useUser(),
    user = _useUser.user;

  /**
   * Fetches product data for the current listing based on the applied search facets.
   */
  function fetchProductListing() {
    return _fetchProductListing.apply(this, arguments);
  }
  /**
   * Gets the product facets.
   *
   * @param      {any}  productListing  The product listing
   * @return     {Facet[]}            The product facets.
   */
  function _fetchProductListing() {
    _fetchProductListing = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _productListing$value, _productListing$value2, _query$sort, _user$value, _user$value$customerG, _productListingCatego2;
      var forcedSort,
        query,
        params,
        priceRange,
        oldSort,
        filters,
        sort,
        _productListing$value3,
        _productListing$value4,
        _productListing$value5,
        _categoryResult$value,
        _categoryResult$value2,
        _categoryResult$value3,
        _categoryResult$value4,
        _categoryResult$value5,
        _categoryResult$value6,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            forcedSort = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
            query = route.query, params = route.params;
            priceRange = getPriceRange();
            oldSort = (_productListing$value = productListing.value) === null || _productListing$value === void 0 ? void 0 : (_productListing$value2 = _productListing$value.input) === null || _productListing$value2 === void 0 ? void 0 : _productListing$value2.sort;
            filters = _objectSpread(_objectSpread({}, facets.value), {}, _defineProperty(_defineProperty({}, ProductAttributes.availableInCountries, [country, 'ALL']), ProductKeys.isProductDiscontinued, ['false']));
            if (priceRange) {
              filters.price = [priceRange];
            }
            sort = Array.isArray(query.sort) ? query === null || query === void 0 ? void 0 : query.sort[0] : (_query$sort = query === null || query === void 0 ? void 0 : query.sort) !== null && _query$sort !== void 0 ? _query$sort : 'pertinence';
            if (forcedSort) sort = forcedSort;
            _context.next = 10;
            return search({
              categorySlug: params === null || params === void 0 ? void 0 : params.slug,
              filters: filters,
              sort: sort,
              page: query !== null && query !== void 0 && query.page ? Number(query.page) : 1,
              perPage: 18,
              customerGroupId: (_user$value = user.value) === null || _user$value === void 0 ? void 0 : (_user$value$customerG = _user$value.customerGroup) === null || _user$value$customerG === void 0 ? void 0 : _user$value$customerG.id
            });
          case 10:
            productListing.value = result.value;

            // Prevents categories from updating whenever filters are added.
            if ((_productListingCatego2 = productListingCategories.value) !== null && _productListingCatego2 !== void 0 && _productListingCatego2.length) {
              _context.next = 15;
              break;
            }
            _context.next = 14;
            return categorySearch({
              slug: (_productListing$value3 = productListing.value) === null || _productListing$value3 === void 0 ? void 0 : (_productListing$value4 = _productListing$value3.data) === null || _productListing$value4 === void 0 ? void 0 : (_productListing$value5 = _productListing$value4.currentCategory) === null || _productListing$value5 === void 0 ? void 0 : _productListing$value5.slug
            });
          case 14:
            productListingCategories.value = (_categoryResult$value = (_categoryResult$value2 = categoryResult.value) === null || _categoryResult$value2 === void 0 ? void 0 : (_categoryResult$value3 = _categoryResult$value2[0]) === null || _categoryResult$value3 === void 0 ? void 0 : (_categoryResult$value4 = _categoryResult$value3.children) === null || _categoryResult$value4 === void 0 ? void 0 : (_categoryResult$value5 = _categoryResult$value4.filter(function (category) {
              return category['slug_' + locale] != null;
            })) === null || _categoryResult$value5 === void 0 ? void 0 : (_categoryResult$value6 = _categoryResult$value5.map(function (category) {
              return {
                id: category.id,
                count: category.stagedProductCount,
                label: category.name,
                route: {
                  name: 'products-slug',
                  params: {
                    slug: category.slug
                  }
                }
              };
            })) === null || _categoryResult$value6 === void 0 ? void 0 : _categoryResult$value6.sort(function (a, b) {
              return b.count - a.count;
            })) !== null && _categoryResult$value !== void 0 ? _categoryResult$value : [];
          case 15:
            // Prevent sort changes from triggering
            // unnecessary page rerender
            if (!oldSort || oldSort === sort) {
              productListingFacets.value = getProductFacets(result.value);
            }
            return _context.abrupt("return", productListing.value);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchProductListing.apply(this, arguments);
  }
  function getProductFacets(productListing) {
    var _propertyFacets$subfa, _problemFacets$subfac, _productListingCatego;
    var facets = getFacetGrouped(productListing, [].concat(_toConsumableArray(PROBLEM_LABELS), _toConsumableArray(PRODUCT_ATTRIBUTES_FILTERS))).filter(function (facet) {
      var _facet$options;
      return (_facet$options = facet.options) === null || _facet$options === void 0 ? void 0 : _facet$options.length;
    });
    var result = [];
    var propertyFacets = {
      id: 'properties',
      label: translate('search.filters.properties'),
      type: 'nested',
      subfacets: []
    };
    var problemFacets = {
      id: 'problems',
      label: translate('search.filters.problems'),
      type: 'nested',
      subfacets: []
    };
    facets.forEach(function (facet) {
      var _facet$options2, _facet$options3;
      facet.label = translate("search.filters.".concat(facet.id));
      if (/^problematiques-/.test(facet.id) && (_facet$options2 = facet.options) !== null && _facet$options2 !== void 0 && _facet$options2.length) {
        problemFacets.subfacets.push(facet);
      } else if (/^proprietes-/.test(facet.id) && (_facet$options3 = facet.options) !== null && _facet$options3 !== void 0 && _facet$options3.length) {
        propertyFacets.subfacets.push(facet);
      } else {
        result.push(facet);
      }
    });
    if ((_propertyFacets$subfa = propertyFacets.subfacets) !== null && _propertyFacets$subfa !== void 0 && _propertyFacets$subfa.length) result.push(propertyFacets);
    if ((_problemFacets$subfac = problemFacets.subfacets) !== null && _problemFacets$subfac !== void 0 && _problemFacets$subfac.length) result.push(problemFacets);
    if ((_productListingCatego = productListingCategories.value) !== null && _productListingCatego !== void 0 && _productListingCatego.length) {
      result.push({
        type: 'link',
        id: 'categories',
        defaultOpened: !isMobile.value,
        label: translate('search.filters.category'),
        options: productListingCategories.value
      });
    }
    result.push({
      id: 'price',
      label: translate('search.filters.price'),
      type: 'range',
      options: {
        min: 0,
        max: 100,
        unit: '€'
      }
    });
    var facetOrder = ['categories', 'properties', 'problems', 'adapte-pour', 'type-de-peaux', 'type-de-cheveux', 'senteur', 'culture', 'price'];
    return facetOrder.flatMap(function (facetId) {
      var facet = result.find(function (facet) {
        return facet.id === facetId;
      });
      return facet ? [facet] : [];
    });
  }

  /**
   * Stores the Contentful content associated with the product listing category, including related advices and recipes.
   */
  var productListingContent = useState("product-listing-content-".concat(slug), function () {
    return null;
  });

  /**
   * Fetches Contentful content associated with the product listing category.
   */
  function fetchProductListingContent() {
    return _fetchProductListingContent.apply(this, arguments);
  }
  /**
   * Computes an array of related advice objects based on the data in `productListingContent`
   */
  function _fetchProductListingContent() {
    _fetchProductListingContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _contentfulData$data, _contentfulData$data$;
      var params, contentfulData;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            params = route.params;
            _context2.next = 3;
            return client.contentful.getProductListingPage.query({
              slug: params.slug,
              locale: locale
            });
          case 3:
            contentfulData = _context2.sent;
            productListingContent.value = contentfulData === null || contentfulData === void 0 ? void 0 : (_contentfulData$data = contentfulData.data) === null || _contentfulData$data === void 0 ? void 0 : (_contentfulData$data$ = _contentfulData$data.pageProductListingPageCollection) === null || _contentfulData$data$ === void 0 ? void 0 : _contentfulData$data$.items[0];
            return _context2.abrupt("return", productListingContent.value);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _fetchProductListingContent.apply(this, arguments);
  }
  var relatedAdvices = computed(function () {
    var _productListingConten5, _productListingConten6, _productListingConten7;
    var result = (_productListingConten5 = productListingContent.value) === null || _productListingConten5 === void 0 ? void 0 : (_productListingConten6 = _productListingConten5.associatedAdvices) === null || _productListingConten6 === void 0 ? void 0 : (_productListingConten7 = _productListingConten6.advicesCollection) === null || _productListingConten7 === void 0 ? void 0 : _productListingConten7.items;
    return result;
  });

  /**
   * Computes an array of related recipe objects based on the data in `productListingContent`.
   */
  var relatedRecipes = computed(function () {
    var _productListingConten8, _productListingConten9, _productListingConten0, _productListingConten1;
    return (_productListingConten8 = productListingContent.value) === null || _productListingConten8 === void 0 ? void 0 : (_productListingConten9 = _productListingConten8.associatedRecipes) === null || _productListingConten9 === void 0 ? void 0 : (_productListingConten0 = _productListingConten9.listOfRecipesCollection) === null || _productListingConten0 === void 0 ? void 0 : (_productListingConten1 = _productListingConten0.items) === null || _productListingConten1 === void 0 ? void 0 : _productListingConten1.flatMap(function (recipe) {
      var _recipe$carouselColle, _recipe$category, _recipe$cosmecticReci, _recipe$cosmecticReci2, _recipe$cosmecticReci3;
      if (!(recipe !== null && recipe !== void 0 && recipe.slug)) return [];
      return [{
        recipeId: recipe === null || recipe === void 0 ? void 0 : recipe.sys.id,
        title: recipe === null || recipe === void 0 ? void 0 : recipe.title,
        cover: recipe === null || recipe === void 0 ? void 0 : (_recipe$carouselColle = recipe.carouselCollection.items) === null || _recipe$carouselColle === void 0 ? void 0 : _recipe$carouselColle[0].url,
        slug: recipe === null || recipe === void 0 ? void 0 : recipe.slug,
        category: (_recipe$category = recipe === null || recipe === void 0 ? void 0 : recipe.category) !== null && _recipe$category !== void 0 ? _recipe$category : recipe === null || recipe === void 0 ? void 0 : (_recipe$cosmecticReci = recipe.cosmecticRecipeFamilyCollection) === null || _recipe$cosmecticReci === void 0 ? void 0 : (_recipe$cosmecticReci2 = _recipe$cosmecticReci.items) === null || _recipe$cosmecticReci2 === void 0 ? void 0 : (_recipe$cosmecticReci3 = _recipe$cosmecticReci2[0]) === null || _recipe$cosmecticReci3 === void 0 ? void 0 : _recipe$cosmecticReci3.parentFamily
      }];
    });
  });

  /**
   * Contentful description for the related recipe block
   */
  var relatedRecipesDescription = computed(function () {
    var _productListingConten10, _productListingConten11, _productListingConten12;
    return (_productListingConten10 = productListingContent.value) === null || _productListingConten10 === void 0 ? void 0 : (_productListingConten11 = _productListingConten10.associatedRecipes) === null || _productListingConten11 === void 0 ? void 0 : (_productListingConten12 = _productListingConten11.fields) === null || _productListingConten12 === void 0 ? void 0 : _productListingConten12.description;
  });
  return {
    productListing: productListing,
    productListingCategories: productListingCategories,
    fetchProductListing: fetchProductListing,
    productListingFacets: productListingFacets,
    productListingContent: productListingContent,
    productListingContentKey: productListingContentKey,
    productListingRelatedCategories: productListingRelatedCategories,
    fetchProductListingContent: fetchProductListingContent,
    relatedAdvices: relatedAdvices,
    relatedRecipes: relatedRecipes,
    relatedRecipesDescription: relatedRecipesDescription
  };
}